export const NATIVE_EMBED_BRIDGE_QUERY_PARAM_KEYS = [
	'nativeEmbedChildId',
	'nativeEmbedParentId',
] as const;
